import styled from 'styled-components';
const ResultListStyled = styled.div`
  flex-grow: 1;
  /* padding: 0 12px; */
  .date-wrapper {
    display: flex;
    flex-direction: column;
  }
  .handle_btn {
    padding: 0 24px;
    justify-content: center;
    display: flex;

    .no-drop {
      cursor: not-allowed;
    }

    > div {
      margin-right: 15px;
    }
    span {
      font-size: 16px;
      /* color: #fff; */
    }
    .icon {
      width: 18px;
      height: 18px;
      fill: '#BDBDBD';
      > svg {
        border: 1px solid red;
      }
    }
    .MuiButtonBase-root {
      height: 40px;
      width: 40px;
    }

    .preview {
      cursor: pointer;
    }
    .canClick {
      cursor: pointer;
    }
    img {
      width: 18px;
      height: 18px;
    }
  }
`;
export default ResultListStyled;
